import constants from '@/config/constants'
import routeSettings from '@/config/routeSettings'
import { head, isEmpty } from 'lodash'
import type { PossibleOorRecipientDto } from '@/api/origin-workflow-svc'

export const logout = () => {
  localStorage.removeItem('currentUser')
}

export const isPublicRoute = (path: string) => {
  let isPublic = false
  routeSettings.PUBLIC_URL.forEach((URL) => {
    if (isPublic) return
    isPublic = !isEmpty(path.match(URL))
  })
  return isPublic
}

export const isPublicPrivateRoute = (path: string) => {
  let isPublicPrivate = false
  routeSettings.PUBLIC_PRIVATE_URL.forEach((URL) => {
    if (isPublicPrivate) return
    isPublicPrivate = !isEmpty(path.match(URL))
  })
  return isPublicPrivate
}

export const isDAR = (grants: string[] = []) => {
  return grants

    .map((grant) => grant.toUpperCase())
    .includes(constants.ROLES.DAR.toUpperCase())
}

export const isLAR = (grants: string[] | null | undefined = []) => {
  return (grants ?? [])
    .map((grant) => grant.toUpperCase())
    .includes(constants.ROLES.LAR.toUpperCase())
}

export const isOnlyLAR = (grants: string[] | null | undefined = []) => {
  const gts = (grants ?? [])
    .map((grant) => grant.toUpperCase())
    .filter((grant) => grant !== constants.ROLES.EMPLOYEE)

  return gts.length === 1 && gts.includes(constants.ROLES.LAR)
}

export const isQAR = (grants: string[] | null | undefined = []) => {
  return (grants ?? [])
    .map((grant) => grant.toUpperCase())
    .includes(constants.ROLES.QAR.toUpperCase())
}

export const isOOR = (
  userId: string,
  recipients: PossibleOorRecipientDto[]
) => {
  return recipients.some((recipient) => recipient.userId === userId)
}

const _titleShortTitleAsRecipient = (
  id: string,
  recipients: PossibleOorRecipientDto[]
) => {
  const recipient = recipients.find((recipient) => recipient.userId === id)
  if (isEmpty(recipient)) return

  const possibleTitleAndGrants = (
    recipient.titleAndGrantStatusList ?? []
  ).filter(
    (titleAndGrant) =>
      !Object.keys(constants.ROLES).includes(
        (titleAndGrant.title ?? '').toUpperCase()
      )
  )

  const shortTitle = head(possibleTitleAndGrants)?.shortTitle
  const title = head(possibleTitleAndGrants)?.title
  return { shortTitle, title }
}

export const shortTitleAsRecipient = (
  id: string,
  recipients: PossibleOorRecipientDto[]
) => {
  const result = _titleShortTitleAsRecipient(id, recipients)
  return result?.shortTitle
}

export const titleAsRecipient = (
  id: string,
  recipients: PossibleOorRecipientDto[]
) => {
  const result = _titleShortTitleAsRecipient(id, recipients)
  return result?.title
}

export const isLARAndOOR = (
  grants: string[] = [],
  oorRecipientRole: string = ''
) => {
  const upperCaseGrants = grants.map((grant) => grant.toUpperCase())
  return (
    upperCaseGrants.includes(constants.ROLES.LAR) &&
    upperCaseGrants.includes(oorRecipientRole.toUpperCase())
  )
}
